const jujoPageComponentTypesMap = {
  jujo_component: 'jujo_component',
  jujo_content: 'jujo_content',
  jujo_element: 'jujo_element',
}
export default jujoPageComponentTypesMap
